module.exports = __webpack_public_path__ + "static/media/ITInnovators.c6d686d5.gif";